'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RenderPlugin = function RenderPlugin() {
  return {
    renderMark: function renderMark(markProps) {
      var marks = markProps.marks,
          attributes = markProps.attributes,
          children = markProps.children;

      if (marks.size > 0 && typeof children === 'string') {
        var classNames = marks.map(function (mark) {
          if (mark.type === 'color') {
            return 'color_' + mark.data.get('color');
          }
          return 'mark_' + mark.type;
        }).join(' ');

        return _react2.default.createElement(
          'span',
          _extends({ className: classNames }, attributes),
          children
        );
      }
      return null;
    },
    renderNode: function renderNode(nodeProps) {
      var attributes = nodeProps.attributes,
          node = nodeProps.node,
          children = nodeProps.children,
          parent = nodeProps.parent;


      switch (node.type) {
        case 'learning-language':
          return _react2.default.createElement(
            'span',
            _extends({ className: 'pattern__learning_language' }, attributes),
            children
          );
        case 'heading-one':
          return _react2.default.createElement(
            'header',
            _extends({ className: 'heading-one' }, attributes),
            children
          );
        case 'heading-two':
          return _react2.default.createElement(
            'header',
            _extends({ className: 'heading-two' }, attributes),
            children
          );
        case 'ol_list':
          return _react2.default.createElement(
            'ol',
            _extends({ className: 'pattern__normal_list' }, attributes),
            children
          );
        case 'ul_list':
          return _react2.default.createElement(
            'ul',
            _extends({ className: 'pattern__normal_list' }, attributes),
            children
          );
        case 'pattern__conversation':
        case 'pattern__examples':
          return _react2.default.createElement(
            'div',
            _extends({ className: node.type + '_block' }, attributes),
            children
          );
        case 'pattern__note':
        case 'pattern__center':
        case 'pattern__cultural':
        case 'pattern__watchout':
        case 'pattern_aside':
          return _react2.default.createElement(
            'div',
            _extends({ className: node.type + '_block' }, attributes),
            children
          );
        case 'list_item':
          if (parent.type === 'ol_list' || parent.type === 'ul_list') {
            return _react2.default.createElement(
              'li',
              _extends({ className: 'pattern__normal_item' }, attributes),
              children
            );
          }
          return _react2.default.createElement(
            'div',
            _extends({ className: 'pattern__' + (node.data.get('className') || 'normal') + '_item' }, attributes),
            children
          );

        default:
          return null;
      }
    }
  };
};

exports.default = RenderPlugin;